import { createGetRequest } from './request.js';
import { API_URLS } from '../constants/urls.js';
export const modifyUtagDataAfterLoginsAndRegistrations = async () => {
    try {
        const standardParametersResponse = await createGetRequest(API_URLS.ANALYTICS.STANDARD_PARAMETERS);
        window.utag_data = {
            ...window.utag_data,
            analytics: {
                ...window.utag_data.analytics,
                legacy: {
                    ...window.utag_data.analytics.legacy,
                    member_id: standardParametersResponse.data.legacyMemberId,
                },
            },
            ...standardParametersResponse.data,
        };
    }
    catch (error) {
        return error;
    }
};
export const addDynamicGlobalTrackingLibraryScript = (scriptUrl) => {
    if (!scriptUrl) {
        console.warn('encodedGTLibraryUrl not found, if runs from GFP this is intended, othwerwise check your tracking');
        return;
    }
    const hasGTScriptAlready = Array.from(document.getElementsByTagName('script')).some((script) => script.src.includes('/sharedassets/@stepstone/global-tracking-frontend'));
    if (hasGTScriptAlready) {
        return;
    }
    const scriptElement = document.createElement('script');
    scriptElement.src = scriptUrl;
    scriptElement.id = 'gt-dynamic-script';
    scriptElement.onload;
    document.body.appendChild(scriptElement);
};
export const removeDynamicGlobalTrackingLibraryScript = () => {
    const scriptElement = document.getElementById('gt-dynamic-script');
    scriptElement && delete window.stst_gt;
    scriptElement?.remove();
};
//# sourceMappingURL=tracking.js.map